import { useEffect, useState } from "react";
import { fetch } from "./fetch";

export function useAsyncList<T>(src: string | (() => Promise<T[]>)): T[] {
  const [data, setData] = useState<T[]>([]);

  useEffect(() => {
    if (typeof src === "string") {
      fetch<T[]>(src).then(setData);
    } else {
      src().then(setData);
    }
  }, []);

  return data;
}
